namespace TabAurous.Retail {
    export namespace POSSalesItemsService {
        export const baseUrl = 'POSSales/POSSalesItems';

        export declare function Create(request: Serenity.SaveRequest<POSSalesItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<POSSalesItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<POSSalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<POSSalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomList(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<POSSalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CheckWithoutTaxItemsCreated(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<POSSalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "POSSales/POSSalesItems/Create",
            Update = "POSSales/POSSalesItems/Update",
            Delete = "POSSales/POSSalesItems/Delete",
            Retrieve = "POSSales/POSSalesItems/Retrieve",
            List = "POSSales/POSSalesItems/List",
            CustomList = "POSSales/POSSalesItems/CustomList",
            CheckWithoutTaxItemsCreated = "POSSales/POSSalesItems/CheckWithoutTaxItemsCreated"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'CustomList', 
            'CheckWithoutTaxItemsCreated'
        ].forEach(x => {
            (<any>POSSalesItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
